export const Intro = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
